module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotAssignModal",
    attrs: {
      "id": "missionSlotAssignModal",
      "title": _vm.missionSlotAssignTitle,
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotAssignData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.assignMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.assign.selection'),
      "state": _vm.missionSlotAssignUserState,
      "description": _vm.$t('mission.slot.assign.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionSlotAssignUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.assignUserSelected
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.assign.force'),
      "state": "success",
      "description": _vm.$t('mission.slot.assign.force.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotAssign.force),
      callback: function($$v) {
        _vm.missionSlotAssign.force = $$v
      },
      expression: "missionSlotAssign.force"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotAssignSuppressNotifications),
      callback: function($$v) {
        _vm.missionSlotAssignSuppressNotifications = $$v
      },
      expression: "missionSlotAssignSuppressNotifications"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.assignMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.assign.mission.slot')) + "\n      ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotAssignModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54030759"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotAssignModal.vue
// module id = 521
// module chunks = 0